<template>
  <b-card>
    <FormView
      :data="$store.getters['sale/detailData']"
      :fields="$store.getters['sale/tableFields']"
      @load="loadData"
    />
  </b-card>
</template>

<script>
import FormView from '@/layouts/components/FormView.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    FormView,
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('sale/getDetail', id)
    },
  },
}
</script>

<style scoped>

</style>
